import React from 'react'
import { Helmet } from 'react-helmet-async'
import { ReferralsLayout } from '../../layouts'

const ReferralsPage = (): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Referrals and coupons</title>
      <meta name="description" content="Referrals and coupons page" />
    </Helmet>
    <ReferralsLayout />
  </React.Fragment>
)

export default ReferralsPage
